import React, { useEffect, useState } from "react";
import LayerAdmin from "../LayerAdmin";
import { getSpecificUser, updateEmployee } from "../api/editEmployee";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import ButtonLoader from "../../zamzam/components/ButtonLoader";
import { toast, ToastContainer } from "react-toastify";
import Loader from "../../../components/Loader";
import URL_MAPPING from "../../../routes/constants";
import Dropdown from "../../../components/Dropdown";

/** Map API boolean | null to dropdown: "", "true", "false" */
function triStateBoolFromApi(v: unknown): string {
  if (v === true || v === "true" || v === 1) return "true";
  if (v === false || v === "false" || v === 0) return "false";
  return "";
}

const EditEmployee = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const isPlanning = location.pathname.includes("planning") || localStorage.getItem("section") === "Planning";
  const [updating, setUpdating] = useState(false);
  const [loading, setLoading] = useState(false);
  const [invalidFields, setInvalidFields] = useState<string[]>([]);
  const [formData, setFormData] = useState({
    emp_id: "",
    name_eng: "",
    name_arb: "",
    email: "",
    mobile_number: "",
    position_id: "",
    position_name: "",
    channel_id: "",
    channel_name: "",
    sales_office_id: "",
    sales_office_name: "",
    supervisor_id: "",
    supervisor_name: "",
    status: "",
    temporary_block:"",
    only_collection_allowed: "No",
    unplanned_approval_required: "",
    unplanned_visit_limit: "",
    is_training_video_completed: "",
    planning_type: "",
    planning_status: "",
  });
  const handleGetEmployee = async () => {
    try {
      if (id) {
        setLoading(true);
        const response = await getSpecificUser(id);
        if (!response) {
          console.warn("Invalid or empty Employee response:", response);
          toast.error("Invalid or empty Employee response",{
            autoClose: false,
            closeOnClick: true,
            draggable: true,
          });
          return;
        }
        setFormData({
          emp_id: response.emp_id ?? "",
          name_eng: response.name_eng ?? "",
          name_arb: response.name_arb ?? "",
          email: response.email ?? "",
          mobile_number: response.mobile_number ?? "",
          position_id: response.position_id ?? "",
          position_name: response.position_name ?? "",
          channel_id: response.channel_id ?? "",
          channel_name: response.channel_name ?? "",
          sales_office_id: response.sales_office_id ?? "",
          sales_office_name: response.sales_office_name ?? "",
          supervisor_id: response.supervisor_id ?? "",
          supervisor_name: response.supervisor_name ?? "",
          status: response.status ?? "",
          temporary_block: response.temporary_block ?? "",
          only_collection_allowed: 
            response.only_collection_allowed === true || 
            response.only_collection_allowed === "true" || 
            response.only_collection_allowed === 1
              ? "Yes" 
              : response.only_collection_allowed === false || 
                response.only_collection_allowed === "false" || 
                response.only_collection_allowed === 0 ||
                response.only_collection_allowed === null ||
                response.only_collection_allowed === undefined
              ? "No"
              : "No",
          unplanned_approval_required: triStateBoolFromApi(
            response.unplanned_approval_required
          ),
          unplanned_visit_limit:
            response.unplanned_visit_limit != null && response.unplanned_visit_limit !== ""
              ? String(response.unplanned_visit_limit)
              : "",
          is_training_video_completed: triStateBoolFromApi(
            response.is_training_video_completed
          ),
          planning_type:
            String(response.planning_type ?? "").toUpperCase() === "ROADNET"
              ? "ROADNET"
              : String(response.planning_type ?? "").toUpperCase() === "SYSTEM"
              ? "SYSTEM"
              : response.planning_type != null ? String(response.planning_type) : "",
          planning_status:
            response.planning_status === "monthly" || response.planning_status === "M"
              ? "M"
              : response.planning_status === "weekly" || response.planning_status === "W"
              ? "W"
              : response.planning_status != null ? String(response.planning_status) : "",
        });
      } else {
        console.error("Invalid ID: ID is undefined");
        toast.error("Id is not defined",{
          autoClose: false,
          closeOnClick: true,
          draggable: true,
        });
        return;
      }
    } catch (error: any) {
      console.error("Error fetching customer data:", error);
      if (error?.response?.status === 404) {
        toast.error("Route not found, Please try again later",{
          autoClose: false,
          closeOnClick: true,
          draggable: true,
        });
      } else if (error?.response?.status === 500) {
        toast.error("Error while fetching the employee",{
          autoClose: false,
          closeOnClick: true,
          draggable: true,
        });
      } else {
        const detail = error?.response?.data?.detail;
        if (Array.isArray(detail)) {
          detail.forEach((err) => toast.error(err.msg));
        } else {
          toast.error(detail?.msg || detail || "An unexpected error occurred.",{
            autoClose: false,
            closeOnClick: true,
            draggable: true,
          });
        }
      }
    } finally {
      setLoading(false);
    }
  };

  const getInputClass = (field: string, isDisabled?: boolean) =>
    `w-full border px-3 py-2 rounded ${
      invalidFields.includes(field) ? "border-red-500" : ""
    } ${isDisabled ? "bg-gray-100 cursor-not-allowed text-gray-500" : ""}`;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const excludeFields = new Set([
    "emp_id",
    "name_eng",
    "name_arb",
    
    "position_name",
    
    "channel_name",
   
    "sales_office_name",
    
    "supervisor_name",
    "status",
  ]);
  


  
  const handleSubmit = async () => {
    try {
      if (id) {
        setUpdating(true);
      //   const emptyFields = Object.entries(formData)
      //   .filter(
      //     ([key, value]) =>
      //       !excludeFields.has(key) && (value === null || value === "")
      //   )
      //   .map(([key]) => key);

      // setInvalidFields(emptyFields);
      setInvalidFields([]);
      // if (emptyFields.length > 0) {
      //   toast.error("Please fill all required fields.");
      //   return;
      // }
        const limitStr = String(formData.unplanned_visit_limit ?? "").trim();
        let unplanned_visit_limit: number | null = null;
        if (limitStr !== "") {
          const n = Number(limitStr);
          unplanned_visit_limit = Number.isNaN(n) ? null : n;
        }

        // Convert only_collection_allowed from Yes/No to true/false; API expects nulls for unset booleans
        const payload = {
          ...formData,
          only_collection_allowed: formData.only_collection_allowed === "Yes",
          unplanned_approval_required:
            formData.unplanned_approval_required === ""
              ? null
              : formData.unplanned_approval_required === "true",
          unplanned_visit_limit,
          is_training_video_completed:
            formData.is_training_video_completed === ""
              ? null
              : formData.is_training_video_completed === "true",
          planning_type:
            String(formData.planning_type ?? "").trim() === ""
              ? null
              : String(formData.planning_type).trim(),
          planning_status:
            String(formData.planning_status ?? "").trim() === ""
              ? null
              : String(formData.planning_status).trim(),
        };
        const response = await updateEmployee(payload, formData.emp_id);
        if (!response) {
          console.warn("Invalid or empty response:", response);
          toast.error("Invalid or empty response",{
            autoClose: false,
            closeOnClick: true,
            draggable: true,
          });
          return;
        }
        toast.success("Employee updated successfully");
        setTimeout(() => {
          if (isPlanning) {
            navigate(URL_MAPPING.PLANNING_EMPLOYEES);
          } else {
            navigate(URL_MAPPING.ADMINPANEL);
          }
        }, 2000);
     
      }
    } catch (error: any) {
      console.error("Error fetching customer data:", error);
      if (error?.response?.status === 404) {
        toast.error("Route not found, Please try again later",{
          autoClose: false,
          closeOnClick: true,
          draggable: true,
        });
      } else if (error?.response?.status === 500) {
        toast.error("Error while fetching the employee",{
          autoClose: false,
          closeOnClick: true,
          draggable: true,
        });
      } else {
        const detail = error?.response?.data?.detail;
        if (Array.isArray(detail)) {
          detail.forEach((err) => toast.error(err.msg));
        } else {
          toast.error(detail?.msg || detail || "An unexpected error occurred.",{
            autoClose: false,
            closeOnClick: true,
            draggable: true,
          });
        }
      }
    } finally {
      setUpdating(false);
    }
  };
  useEffect(() => {
    handleGetEmployee();
  }, []);
  return (
    <LayerAdmin>
      <ToastContainer />
      {loading ? (
        <Loader />
      ) : (
        <>
          <div className="flex items-center px-5 pt-5 gap-3">
            <button
              onClick={() => {
                if (isPlanning) {
                  navigate(URL_MAPPING.PLANNING_EMPLOYEES);
                } else {
                  window.history.back();
                }
              }}
              className="bg-gray-200 text-gray-700 px-4 py-2 rounded hover:bg-gray-300"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                version="1.1"
                width="10"
                height="10"
                viewBox="0 0 256 256"
                xmlSpace="preserve"
              >
                <g
                  style={{
                    stroke: "none",
                    strokeWidth: 0,
                    strokeDasharray: "none",
                    strokeLinecap: "butt",
                    strokeLinejoin: "miter",
                    strokeMiterlimit: 10,
                    fill: "none",
                    fillRule: "nonzero",
                    opacity: 1,
                  }}
                  transform="translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
                >
                  <polygon
                    points="20.48,45 59.75,90 69.52,81.48 37.69,45 69.52,8.52 59.75,0 "
                    style={{
                      stroke: "none",
                      strokeWidth: 1,
                      strokeDasharray: "none",
                      strokeLinecap: "butt",
                      strokeLinejoin: "miter",
                      strokeMiterlimit: 10,
                      fill: "rgb(0,0,0)",
                      fillRule: "nonzero",
                      opacity: 1,
                    }}
                    transform="  matrix(1 0 0 1 0 0) "
                  />
                </g>
              </svg>
            </button>
            <h3 className="text-xl font-bold text-gray-700">
              {isPlanning ? "Edit Employee Planning" : "Edit Employee"}
            </h3>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-sm px-5 pt-5">
  <div>
    <label className="block font-semibold mb-1">Employee ID</label>
    <input
      type="text"
      value={formData.emp_id}
      disabled
      onChange={handleChange}
      className="w-full border px-3 py-2 rounded bg-gray-100 cursor-not-allowed text-gray-500"
    />
  </div>

  <div>
    <label className="block font-semibold mb-1">Name (ENG)</label>
    <input
      type="text"
      value={formData.name_eng}
      disabled
      name="name_eng"
      onChange={handleChange}
      className="w-full border px-3 py-2 rounded bg-gray-100 cursor-not-allowed text-gray-500"
    />
  </div>

  <div>
    <label className="block font-semibold mb-1">Name (ARB)</label>
    <input
      type="text"
      value={formData.name_arb}
      disabled
      name="name_arb"
      onChange={handleChange}
      className="w-full border px-3 py-2 rounded bg-gray-100 cursor-not-allowed text-gray-500"
    />
  </div>

  <div>
    <label className="block font-semibold mb-1">Email*</label>
    <input
      type="email"
      value={formData.email}
      disabled={isPlanning}
      onChange={handleChange}
      name="email"
      className={getInputClass("email", isPlanning)}
    />
  </div>

  <div>
    <label className="block font-semibold mb-1">Mobile Number*</label>
    <input
      type="text"
      value={formData.mobile_number}
      disabled={isPlanning}
      onChange={handleChange}
      name="mobile_number"
      className={getInputClass("mobile_number", isPlanning)}
    />
  </div>

  <div>
    <label className="block font-semibold mb-1">Position ID*</label>
    <input
      type="text"
      value={formData.position_id}
      disabled={isPlanning}
      onChange={handleChange}
      name="position_id"
      className={getInputClass("position_id", isPlanning)}
    />
  </div>

  <div>
    <label className="block font-semibold mb-1">Position Name</label>
    <input
      type="text"
      value={formData.position_name}
      disabled
      onChange={handleChange}
      name="position_name"
      className="w-full border px-3 py-2 rounded bg-gray-100 cursor-not-allowed text-gray-500"
    />
  </div>
  <div>
    <Dropdown
      label="Temporary Block"
      labelClassName="font-semibold mb-1 text-black"
      disabled={isPlanning}
      options={[
        { value: "true", label: "True" },
        { value: "false", label: "False" },
      ]}
      selectedValue={formData.temporary_block}
      onChange={(value) =>
        setFormData((prev) => ({ ...prev, temporary_block: String(value) }))
      }
      placeholder="Select"
    />
  </div>

  <div>
    <label className="block font-semibold mb-1">Channel ID</label>
    <input
      type="text"
      value={formData.channel_id}
      disabled={isPlanning}
      onChange={handleChange}
      name="channel_id"
      className={getInputClass("channel_id", isPlanning)}
    />
  </div>

  <div>
    <label className="block font-semibold mb-1">Channel Name</label>
    <input
      type="text"
      onChange={handleChange}
      value={formData.channel_name}
      disabled
      name="channel_name"
      className="w-full border px-3 py-2 rounded bg-gray-100 cursor-not-allowed text-gray-500"
    />
  </div>

  <div>
    <label className="block font-semibold mb-1">Sales Office ID*</label>
    <input
      type="text"
      value={formData.sales_office_id}
      disabled={isPlanning}
      onChange={handleChange}
      name="sales_office_id"
      className={getInputClass("sales_office_id", isPlanning)}
    />
  </div>

  <div>
    <label className="block font-semibold mb-1">Sales Office Name</label>
    <input
      type="text"
      value={formData.sales_office_name}
      disabled
      onChange={handleChange}
      name="sales_office_name"
      className="w-full border px-3 py-2 rounded bg-gray-100 cursor-not-allowed text-gray-500"
    />
  </div>

  <div>
    <label className="block font-semibold mb-1">Supervisor ID</label>
    <input
      type="text"
      value={formData.supervisor_id}
      disabled={isPlanning}
      onChange={handleChange}
      name="supervisor_id"
      className={getInputClass("supervisor_id", isPlanning)}
    />
  </div>

  <div>
    <label className="block font-semibold mb-1">Supervisor Name</label>
    <input
      type="text"
      value={formData.supervisor_name}
      disabled
      onChange={handleChange}
      name="supervisor_name"
      className="w-full border px-3 py-2 rounded bg-gray-100 cursor-not-allowed text-gray-500"
    />
  </div>

  <div>
    <Dropdown
      label="Status"
      labelClassName="font-semibold mb-1 text-black"
      disabled={isPlanning}
      options={[
        { value: "A", label: "Active" },
        { value: "I", label: "Inactive" },
      ]}
      selectedValue={formData.status}
      onChange={(value) =>
        setFormData((prev) => ({ ...prev, status: String(value) }))
      }
      placeholder="Select status"
    />
  </div>

  <div>
    <Dropdown
      label="Allow Collection Only"
      labelClassName="font-semibold mb-1 text-black"
      disabled={isPlanning}
      options={[
        { value: "No", label: "No" },
        { value: "Yes", label: "Yes" },
      ]}
      selectedValue={formData.only_collection_allowed}
      onChange={(value) =>
        setFormData((prev) => ({ ...prev, only_collection_allowed: String(value) }))
      }
      placeholder="Select"
    />
  </div>

  <div>
    <Dropdown
      label="Unplanned approval required"
      labelClassName="font-semibold mb-1 text-black"
      disabled={isPlanning}
      options={[
        { value: "", label: "—" },
        { value: "true", label: "True" },
        { value: "false", label: "False" },
      ]}
      selectedValue={formData.unplanned_approval_required}
      onChange={(value) =>
        setFormData((prev) => ({
          ...prev,
          unplanned_approval_required: String(value),
        }))
      }
      placeholder="Select"
    />
  </div>

  <div>
    <label className="block font-semibold mb-1">Unplanned visit limit</label>
    <input
      type="number"
      min={0}
      step={1}
      disabled={isPlanning}
      value={formData.unplanned_visit_limit}
      onChange={(e) =>
        setFormData((prev) => ({
          ...prev,
          unplanned_visit_limit: e.target.value,
        }))
      }
      className={`w-full border px-3 py-2 rounded ${
        isPlanning ? "bg-gray-100 cursor-not-allowed text-gray-500" : ""
      }`}
      placeholder="Leave empty for none"
    />
  </div>

  <div>
    <Dropdown
      label="Training video completed"
      labelClassName="font-semibold mb-1 text-black"
      disabled={isPlanning}
      options={[
        { value: "", label: "—" },
        { value: "true", label: "True" },
        { value: "false", label: "False" },
      ]}
      selectedValue={formData.is_training_video_completed}
      onChange={(value) =>
        setFormData((prev) => ({
          ...prev,
          is_training_video_completed: String(value),
        }))
      }
      placeholder="Select"
    />
  </div>

  <div>
    <Dropdown
      label="Planning type"
      labelClassName="font-semibold mb-1 text-black"
      options={[
        { value: "ROADNET", label: "Roadnet" },
        { value: "SYSTEM", label: "System" },
      ]}
      selectedValue={formData.planning_type}
      onChange={(value) =>
        setFormData((prev) => ({
          ...prev,
          planning_type: String(value),
        }))
      }
      placeholder="Select"
    />
  </div>

  <div>
    <Dropdown
      label="Planning status"
      labelClassName="font-semibold mb-1 text-black"
      options={[
        { value: "M", label: "Monthly" },
        { value: "W", label: "Weekly" },
      ]}
      selectedValue={formData.planning_status}
      onChange={(value) =>
        setFormData((prev) => ({
          ...prev,
          planning_status: String(value),
        }))
      }
      placeholder="Select"
    />
  </div>
</div>



          <div className="mt-4 px-5">
            <button
              disabled={updating}
              onClick={handleSubmit}
              className="bg-teal-500 text-white px-6 py-2 rounded hover:bg-teal-600 flex items-center gap-2"
            >
              Update Employee {updating && <ButtonLoader />}
            </button>
          </div>
        </>
      )}
    </LayerAdmin>
  );
};

export default EditEmployee;
